import React, { Component, PropTypes } from 'react';
import injectSheet from 'react-jss';
import { FlatButton } from 'material-ui';

const styles = {
  header: {
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    flexWrap: 'no-wrap',
    justifyContent: 'space-between',
    marginBottom: '8px',
    padding: '6px',
    textAlign: 'center',
  },
};

class CommentsTitle extends Component {
  render() {
    return (<div className={`${this.props.classes.header}${this.props.className ? ` ${this.props.className}` : ''}`}>
      <div>These messages are associated with a contract with <b>{this.props.recipientName}</b>.</div>
      <FlatButton
        label="View Contract"
        secondary
        onTouchTap={this.props.linkAction}
        style={{ border: '1px solid green', marginTop: '6px' }}
        labelStyle={{ color: 'green' }}
      />
    </div>
    );
  }
}

CommentsTitle.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  linkAction: PropTypes.func,
  recipientName: PropTypes.string,
};

export default injectSheet(styles)(CommentsTitle);



// WEBPACK FOOTER //
// ./src/app/components/contracting/comments/comments-title.jsx